export default "<ul> <li ng-if=vm.loading>...</li> <li ng-if=!vm.loading>{{ vm.kpiCheckResults.checkName }}</li> <li ng-if=!vm.loading>{{ vm.kpiCheckResults.result ? vm.kpiCheckResults.result + '%' : 'n/a' }}</li> </ul>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/checkLists/checkListKPI.linesheet.tpl.html
// module id = 579
// module chunks = 0